type CountryOption = { value: string; label: string; icon: string }

export const getLocalizedCountryLabel = (
  code: string,
  fallback: string,
  language: string
): string => {
  try {
    const name = new Intl.DisplayNames([language, 'en'], { type: 'region' }).of(code)
    return name && name !== code ? name : fallback
  } catch {
    return fallback
  }
}

export const localizeCountries = <T extends CountryOption>(
  countryList: T[],
  language: string
): T[] =>
  countryList.map((country) => ({
    ...country,
    label: getLocalizedCountryLabel(country.value, country.label, language),
  }))
